import styled from 'styled-components';
import { darkgrey, white } from 'styles/Colors';

export const SectionHeaderWrapper = styled.div`
  width: 100%;
  min-height: 24px;
  border-radius: 5px;
  background-image: linear-gradient(92deg, ${darkgrey}, rgba(65, 65, 65, 0.82));
  padding: 4px 8px;
  font-family: 'Lato';
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.46px;
  color: ${white};
  position: relative;
  overflow: hidden;
  &.back {
    max-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  svg {
    cursor: pointer;
    path {
      fill: ${white};
    }
  }
`;

export const BreadcrumbIcon = styled.span`
  margin-right: 4px;
`;

export const ExpandIconWrapper = styled.span`
  svg {
    transition: all 0.3s;
    position: absolute;
    top: -4px;
    right: 2px;
    &.expanded {
      transform: rotate(180deg);
    }
  }
`;

export const Title = styled.span`
  &.back-title {
    margin-left: 12px;
  }
`;

export const BackIconWrapper = styled.span`
  position: absolute;
  top: -4px;
  left: 0px;
`;
